import { render, staticRenderFns } from "./70.vue?vue&type=template&id=0d0ddd7d&scoped=true&"
import script from "./70.vue?vue&type=script&lang=js&"
export * from "./70.vue?vue&type=script&lang=js&"
import style0 from "./70.vue?vue&type=style&index=0&id=0d0ddd7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0ddd7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSlider } from 'vuetify/lib'
installComponents(component, {VSlider})
